import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Paper from '@mui/material/Paper';
import {pink} from '@mui/material/colors';
import {Tooltip, BarChart, Bar, ResponsiveContainer, XAxis, YAxis, CartesianGrid} from 'recharts';
import { Box } from '@mui/material';


const s:any = {
  paper: {
    backgroundColor: 'white',
    minHeight: 400,
    // overFlow: 'hidden'
  },
  div: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '95%',
    height: 300,
  },
  header: {
    color: 'white',
    backgroundColor: pink['600'],
    padding: 1,
    fontSize: 24,
    fontWeight: 300,
  },
  custom_tooltip:{
    lineHeight: 0.2,
    backgroundColor: 'white',
    padding: 5
  },
  nodata: {
    display: 'flex',
    justifyContent: 'center'
  },
  barchart:{
    marginTop: 20
  }
};

class MonthlyRequests extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      count: 0,
      mode: 'total', //amount
    };
  }

  // componentWillReceiveProps(nextProps) {
  //   if (this.props.page !== nextProps.page) {
  //       this.setState({page: nextProps.page});
  //   }
  // }

  convert = (data:any,mode:any) => {
    var names = ['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var rtn = data.map((item:any) =>(
      {name:names[item.dmonth],year:item.dyear,value:item[mode]}
    ));
    //console.log('month',rtn);
    return rtn;
  }

  customTooltip = ({active, payload, label}: any) => {
    const {classes} = this.props;
    if(payload === null || payload === undefined) return null;
    
    if(active){
      const {payload:rec} = payload[0];
      //console.log('payload:',rec,JSON.stringify(rec));
      return(
        <Box sx={{...s.custom_tooltip}}>
          <Box component='p'>{label}</Box>
          <Box component='p' sx={{...s.revenue}}>{`${rec.tot} events`}</Box>
        </Box>
      )
    }
    return null;
  }

  render() {
    const {data,title='Monthly Events',classes} = this.props;
    //const {mode} = this.state;
    //const chartdata = this.convert(data,mode);
    //  width={730} height={250}
    return (
      <Paper sx={{...s.paper}}>
        <Box sx={{...s.header}}>{title}</Box>
        <Box sx={{...s.div}}>
          <ResponsiveContainer >
            {data.length>0?
            <BarChart style={{...s.barchart}} data={data} >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="nam"/>
              <YAxis dataKey="tot" />
              {/* <Tooltip /> */}
              <Tooltip content={<this.customTooltip />} />
              <Bar dataKey="tot" name="Events" fill={pink['500']}/>
            </BarChart>
            : <Box sx={{...s.nodata}}>No data to show</Box>}
          </ResponsiveContainer>
        </Box>
      </Paper>
    );
  }
}

MonthlyRequests.propTypes = {
  data: PropTypes.array
};

export default MonthlyRequests;
